import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  clients: [],
  filteredClients: [],
  loading: false,
  error: null,
  pagination: {
    page: 1,
    limit: 10,
    total: 0,
  },
  filters: {
    search: '',
    sortBy: [],
    genderBy: [],
    showLossClient: false,
  },
  checkedClients: [],
  updatedClientData: {
    clientName: '',
    clientNumber: '',
    clientAddress: { address: '' },
    clientEmail: '',
    gender: '',
    birthday: '',
    anniversary: '',
    clientNote: '',
  },
  updatedClientId: null,
};
const fuzzyMatch = (text, search) => {
  if (!search) return true;
  const lowerText = text?.toLowerCase().replace(/\s/g, '');
  if (!lowerText) return false;

  const lowerSearch = search.toLowerCase().replace(/\s/g, '');

  let textIndex = 0;
  let searchIndex = 0;
  while (textIndex < lowerText.length && searchIndex < lowerSearch.length) {
    if (lowerText[textIndex] === lowerSearch[searchIndex]) {
      searchIndex++;
    }
    textIndex++;
  }
  return searchIndex === lowerSearch.length;
};

const clientSlice = createSlice({
  name: 'client',
  initialState,
  reducers: {
    // setClients: (state, action) => {
    //   state.clients = action.payload;
      
    //   // Filtering
    //   let filteredData = action.payload.filter((item) => {
    //     const isGenderMatch = state.filters.genderBy.length === 0 || 
    //                        state.filters.genderBy.includes(item?.gender);
    //     const isSearchMatch = !state.filters.search || 
    //                        item?.clientName?.toLowerCase().includes(state.filters.search.toLowerCase()) || 
    //                        item.clientNumber.includes(state.filters.search);
    //     return isGenderMatch && isSearchMatch;
    //   });

    //   // Sorting
    //   if (state.filters.sortBy.length > 0) {
    //     filteredData.sort((a, b) => {
    //       for (const sort of state.filters.sortBy) {
    //         const aValue = a[sort];
    //         const bValue = b[sort];
    //         if (typeof aValue === 'number' && typeof bValue === 'number') {
    //           const diff = bValue - aValue;
    //           if (diff !== 0) return diff;
    //         }
    //       }
    //       return 0;
    //     });
    //   }

    //   // Pagination
    //   const startIndex = (state.pagination.page - 1) * state.pagination.limit;
    //   const endIndex = startIndex + state.pagination.limit;
    //   state.filteredClients = filteredData.slice(startIndex, endIndex);
    //   state.pagination.total = filteredData.length;
    // },
    setClients: (state, action) => {
  state.clients = action.payload;
  
  // Filtering
  let filteredData = action.payload.filter((item) => {
    const isGenderMatch = state.filters.genderBy.length === 0 || 
                         state.filters.genderBy.includes(item?.gender);
    const isSearchMatch = fuzzyMatch(item?.clientName, state.filters.search) ||
          fuzzyMatch(item?.clientNumber, state.filters.search);
    return isGenderMatch && isSearchMatch;
  });

  // Sorting
  if (state.filters.sortBy.length > 0) {
    filteredData.sort((a, b) => {
      for (const sort of state.filters.sortBy) {
        const aValue = a[sort];
        const bValue = b[sort];
        if (typeof aValue === 'number' && typeof bValue === 'number') {
          const diff = bValue - aValue;
          if (diff !== 0) return diff;
        }
      }
      return 0;
    });
  }

  // Pagination
  const startIndex = (state.pagination.page - 1) * state.pagination.limit;
  const endIndex = startIndex + state.pagination.limit;
  state.filteredClients = filteredData.slice(startIndex, endIndex);
  state.pagination.total = filteredData.length;
  
  // IMPORTANT: Update checked clients to only include those that are still in the filtered results
  const filteredClientIds = new Set(filteredData.map(client => client._id));
  // state.checkedClients = state.checkedClients.filter(client => 
  //   filteredClientIds.has(client._id)
  // );
},
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setPage: (state, action) => {
      state.pagination.page = action.payload;
      // Reapply filters with new page
      clientSlice.caseReducers.setClients(state, { payload: state.clients });
    },
    setLimit: (state, action) => {
      state.pagination.limit = action.payload;
      state.pagination.page = 1;
      // Reapply filters with new limit
      clientSlice.caseReducers.setClients(state, { payload: state.clients });
    },
    setSearch: (state, action) => {
      state.filters.search = action.payload;
      state.pagination.page = 1;
      // Reapply filters with new search
      clientSlice.caseReducers.setClients(state, { payload: state.clients });
    },
    setSortBy: (state, action) => {
      state.filters.sortBy = action.payload;
      // Reapply filters with new sort
      clientSlice.caseReducers.setClients(state, { payload: state.clients });
    },
    setGenderBy: (state, action) => {
      state.filters.genderBy = action.payload;
      // Reapply filters with new gender filter
      clientSlice.caseReducers.setClients(state, { payload: state.clients });
    },
    setShowLossClient: (state, action) => {
      state.filters.showLossClient = action.payload;
    },
    setCheckedClients: (state, action) => {
      state.checkedClients = action.payload;
    },
         // ✅ ADD new action to manually clear checked clients
    clearCheckedClients: (state) => {
      state.checkedClients = [];
    },
    
    // ✅ ADD new action to remove specific clients from checked list
    removeFromCheckedClients: (state, action) => {
      const clientIdsToRemove = action.payload;
      state.checkedClients = state.checkedClients.filter(
        client => !clientIdsToRemove.includes(client._id)
      );
    },
    setUpdatedClientData: (state, action) => {
      const { field, value } = action.payload;
      if (field === 'address') {
        state.updatedClientData.clientAddress = { address: value };
      } else {
        state.updatedClientData[field] = value;
      }
    },
    setUpdatedClient: (state, action) => {
      const client = action.payload;
      state.updatedClientData = {
        clientName: client.clientName,
        clientNumber: client.clientNumber,
        clientAddress: client.clientAddress || { address: '' },
        clientEmail: client.clientEmail,
        gender: client.gender,
        birthday: client.birthday,
        anniversary: client.anniversary,
        clientNote: client.clientNote,
      };
      state.updatedClientId = client._id;
    },
    resetUpdatedClient: (state) => {
      state.updatedClientData = initialState.updatedClientData;
      state.updatedClientId = null;
    },
    // clearFilters: (state) => {
    //   return {
    //     ...state,
    //     filters: {
    //       ...initialState.filters,
    //       showLossClient: state.filters.showLossClient, // Keep the showLossClient value
    //     },
    //     pagination: {
    //       ...initialState.pagination,
    //     },
    //     filteredClients: [],
    //   };
    // },
        clearFilters: (state) => {
  return {
    ...state,
    filters: {
      ...initialState.filters, // This will reset showLossClient to false
    },
    pagination: {
      ...initialState.pagination,
    },
    filteredClients: [],
  };
},
    updateClientInState: (state, action) => {
      const updatedClient = action.payload;
      const clientId = updatedClient._id;
      
      const updateInArray = (array) => 
        array.map(item => item._id === clientId ? { ...item, ...updatedClient } : item);
      
      state.clients = updateInArray(state.clients);
      state.filteredClients = updateInArray(state.filteredClients);
      state.checkedClients = updateInArray(state.checkedClients);
      
      if (state.updatedClientId === clientId) {
        state.updatedClientData = { 
          ...state.updatedClientData, 
          ...updatedClient 
        };
      }
    },
    // removeClientFromState: (state, action) => {
    //   const clientId = action.payload;
    //   state.clients = state.clients.filter(client => client._id !== clientId);
    //   // Reapply filters after removal
    //   clientSlice.caseReducers.setClients(state, { payload: state.clients });
    // },
       removeClientFromState: (state, action) => {
      const clientId = action.payload;
      state.clients = state.clients.filter(client => client._id !== clientId);
      // Also remove from checked clients
      state.checkedClients = state.checkedClients.filter(client => client._id !== clientId);
      // Reapply filters after removal
      clientSlice.caseReducers.setClients(state, { payload: state.clients });
    },
  },
});

export const {
  setClients,
  setLoading,
  setPage,
  setLimit,
  setSearch,
  setSortBy,
  setGenderBy,
  setShowLossClient,
  setCheckedClients,
  setUpdatedClientData,
  setUpdatedClient,
  resetUpdatedClient,
  clearFilters,
  updateClientInState,
  removeClientFromState,
  clearCheckedClients, // ✅ Export new action
  removeFromCheckedClients,
} = clientSlice.actions;

export default clientSlice.reducer;